import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-5.293 4.953a1 1 0 0 0 -1.707 .707v6c0 .217 .07 .433 .21 .613l.083 .094a1 1 0 0 0 1.414 0l3 -3a1 1 0 0 0 0 -1.414z","key":"svg-0"}]]

const IconCircleCaretRightFilled = createReactComponent('filled', 'circle-caret-right-filled', 'CircleCaretRightFilled', __iconNode);

export default IconCircleCaretRightFilled;